import { SET_CHECK_RESULT_CODE } from '../actions/checkResult'

const defaultState = {
  code: '1',
  ruleResult: '1',
}

export function checkResult(state = defaultState, action) {
  switch (action.type) {
    case SET_CHECK_RESULT_CODE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}